import React from 'react';

import FilesList from './component';

export default React.memo(FilesList);
